<template>
  <div class="transition-list">
    <div class="transition-list-header">
      转场动画
      <span
        class="icon close iconfont icon-close"
        @click="handleShowTransitionList(false)"
      ></span>
    </div>

    <div class="list">
      <div
        :class="[
          'list-item',
          {
            'list-item-active': item.type === type
          }
        ]"
        v-for="item in list"
        :key="item.type"
        @click="changeType(item.type)"
      >
        <div class="list-item-preview">
          <template v-if="item.type !== 'none'">
            <img
              :src="'/preview/icon/' + item.type + '.png'"
              alt
              class="preview-image"
            />
            <img
              :src="'/preview/icon/' + item.type + '.gif'"
              alt
              class="preview-image-gif"
            />
          </template>
          <!-- it is counter intuitive to display the text below -->
          <!-- <div class="selected" v-show="item.type === type">当前</div> -->
        </div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
    <div class="transition-footer">
      <a-collapse
        expandIconPosition="right"
        :bordered="false"
        class="transition-list-advanced-options"
        ref="collapse"
        :activeKey="type === 'none' ? [] : ['advanced']"
      >
        <a-collapse-panel
          key="advanced"
          header="高级选项"
          :disabled="type === 'none'"
        >
          <a-row>
            <a-col :span="10">
              <a-row type="flex" align="middle">
                <a-col>时长</a-col>
                <a-col :offset="1" flex="1 0" style="display: flex">
                  <a-input-number
                    class="transition-list-advanced-options__input transition-list-advanced-options__input--time"
                    :defaultValue="0"
                    v-model="duration"
                    :min="0"
                    :step="0.1"
                  />
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-collapse-panel>
      </a-collapse>
      <div class="transition-footer__actions">
        <a-button class="action-btn" @click="handleCancel">取消</a-button>
        <a-button class="action-btn" type="primary" @click="handleOK"
          >确定</a-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';

export default {
  name: "TransitionList",
  data: function () {
    return {
      type: 'none',
      duration: 1,
      panelOpen: false
    }
  },
  computed: {
    ...mapGetters(['activeTransitionFragment']),
    ...mapState(['transitionNames', 'transitions']),
    collapsePanel() {
      return this.$refs.collapse.$children[0];
    },
    list() {
      return ['none'].concat(this.transitions).map(type => ({ type, name: this.transitionNames[type] }));
    }
  },
  methods: {
    ...mapMutations(['handleShowTransitionList']),
    init() {
      if (this.activeTransitionFragment && this.activeTransitionFragment.transition) {
        this.type = this.activeTransitionFragment.transition.name;
        this.duration = this.activeTransitionFragment.transition.duration / 1e3;
      } else {
        this.type = 'none';
        this.duration = 1;
      }
    },
    handleCancel() {
      this.init();
      this.handleShowTransitionList(false);
    },
    changeType(type) {
      this.type = type;
      this.duration = 1;
    },
    handleOK() {
      const value = this.type;
      let after = 0;
      const usedDuration = this.duration * 1e3;
      this.$store.commit('handleFragments', this.$store.state.fragments.map(frag => {
        if (after) {
          return {
            ...frag,
            start: frag.start + after
          };
        }
        if (frag === this.activeTransitionFragment) {
          const origDuration = frag.transition ? frag.transition.duration : 0;
          const nextDuration = value === 'none' ? 0 : usedDuration;

          if (origDuration !== nextDuration) {
            after = origDuration - nextDuration;
          }

          return {
            ...frag,
            transition: value === 'none' || usedDuration === 0
              ? null
              : {
                duration: usedDuration,
                start: frag.duration - usedDuration,
                name: value
              }
          };
        }
        return frag;
      }));
      this.handleShowTransitionList(false);
    }
  },
  watch: {
    activeTransitionFragment() {
      console.log(this.$refs.collapse);
      this.init();
    }
  }
}
</script>

<style scoped>
.transition-list {
  padding: 22px 0 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.transition-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 400;
  color: rgba(96, 99, 100, 1);
  padding: 0 20px 8px;
}

.close {
  cursor: pointer;
  font-size: 20px;
}

.close:hover,
.close:focus {
  color: #e57;
}

.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  align-content: start;
  flex-grow: 1;
  padding: 16px 20px;
  overflow: auto;
  position: relative;
}

.list-item {
  width: 160px;
  cursor: pointer;
  margin-bottom: 4px;
}

.name {
  font-size: 12px;
  font-weight: 400;
  color: rgba(96, 99, 100, 1);
  line-height: 28px;
  text-align: center;
}

.list-item-preview {
  border: 2px solid rgba(231, 236, 236, 1);
}

.list-item-preview,
.preview-image {
  width: 160px;
  height: 93px;
  background: #fff;
  position: relative;
}

.preview-image,
.preview-image-gif {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.preview-image-gif {
  visibility: hidden;
  opacity: 0;
  transition: 0.15s;
}

.list-item-preview:hover .preview-image {
  visibility: hidden;
  transition-delay: 0.6s;
}

.list-item-preview:hover .preview-image-gif {
  visibility: visible;
  opacity: 1;
  transition-delay: 0.4s;
}

.list-item-active .list-item-preview,
.list-item-preview:hover {
  border-color: #007fff;
}

.list-item-active .name {
  color: #007fff;
}

.selected {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 37px;
  height: 19px;
  background: #0f77ff;
  font-size: 12px;
  font-weight: 400;
  color: rgba(252, 255, 255, 1);
  text-align: center;
  line-height: 19px;
}

.transition-footer {
  width: 100%;
  background: #f7f8f9;
  border-top: 1px solid #dcdcde;
}

.transition-footer__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 0;
}

.action-btn {
  margin-right: 20px;
}

.transition-list-advanced-options {
  background-color: transparent;
}

.transition-list-advanced-options__input {
  border-radius: 2px;
  width: 80px;
  flex-grow: 1;
  border-color: #dcdcde;
  height: 28px;
  font-size: 100%;
}

.transition-list-advanced-options__input--time:before {
  content: "s";
  position: absolute;
  right: 6px;
  top: 0;
  line-height: 26px;
}
</style>
<style>
.transition-list-advanced-options .ant-collapse-item {
  border-color: #dcdcde;
  /* box-shadow: 0 0 14px rgba(0, 0, 0, 0.06); */
}

.transition-list-advanced-options > .ant-collapse-item > .ant-collapse-header {
  padding: 8px 40px 8px 20px;
  color: inherit;
}

/* .transition-list-advanced-options .ant-collapse-item-active {
  background-color: #fff;
} */

.transition-list-advanced-options
  .ant-collapse-item-disabled
  .ant-collapse-header {
  color: rgba(0, 0, 0, 0.2);
}

.transition-list-advanced-options
  > .ant-collapse-item
  > .ant-collapse-header
  .ant-collapse-arrow {
  right: 18px;
}

.transition-list-advanced-options .ant-collapse-content-box {
  padding-right: 20px;
  padding-left: 20px;
  font-size: 12px;
}

.transition-list-advanced-options__input .ant-input-number-input {
  height: 26px;
}

.transition-list-advanced-options__input .ant-select-selection {
  border-radius: 2px;
  border-color: #dcdcde;
  height: 100%;
}

.transition-list-advanced-options__input .ant-select-selection__rendered {
  line-height: 26px;
}
</style>